import { createAsyncThunk } from "@reduxjs/toolkit";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import { handleError } from "@/shared/lib/helpers/utils";
import { ApiError, APIReadingRequestDetails } from "@/shared/types";

interface Params {
  id: string;
  abortController?: AbortController;
}

export const fetchDetails = createAsyncThunk<APIReadingRequestDetails, Params, ThunkConfig<ApiError>>(
  "readingDetailsPage/fetchDetails",
  async ({ id, abortController }, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
      const response = await extra.api.get<APIReadingRequestDetails>(`/api/reading_requests/${id}`, {
        signal: abortController?.signal,
      });

      return response.data;
    } catch (err) {
      return rejectWithValue(handleError(err));
    }
  }
);
